import styled from "styled-components";

export const Container = styled.div`
  height: 5rem;
  text-align: center;
  background: var(--purple);
`

export const Title = styled.h1`
 padding-top: 2rem;
 color: var(--white);
`
